import * as Roles from '@/store/roles';

export const todoTemplateActionsPermissions = {
  syncTodoTemplate: [Roles.Any],
  getTodoTemplate: [Roles.Any],
  getTodoTemplates: [Roles.Any],
  deleteTodoTemplate: [Roles.Any],
  addTodoItemsFromTemplate: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  addTodoTemplateFromItems: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  addTodoTemplate: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  loadProjectTodoTemplates: [Roles.Any],
  saveTodoTemplateProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  saveTodoTemplateItemProperties: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
};



// WEBPACK FOOTER //
// ./src/store/todoItem/todoTemplateActionsPermissions.js